import React from 'react';
import ArchitectureLayout from '../layouts/ArchitectureLayout';

const ArchitectureDashboard: React.FC = () => {
    return <ArchitectureLayout />;
};

export default ArchitectureDashboard;
